import React from "react";
import { Row } from "reactstrap";
import { getFormattedDateString } from "../../helpers/utils";
import { Colxx } from "../common/CustomBootstrap";

export const ProductDetailHeader = ({ title, subTitle }) => {
  return (
    <Row className="product-details-header ">
      <Colxx sm="12" md="6">
        <div className="product-basic-info-wrapper">
          <h4 className="product-title mb-0">{title}</h4>
          {subTitle ? <small>{subTitle}</small> : null}
        </div>
      </Colxx>
    </Row>
  );
};
